export function capitalizeWords(fullName: string) {

  if (!fullName) {
    return "";
  }
  return fullName
    .toLowerCase()
    .split(' ')
    .map(word => (word === "null" ? "" : word.charAt(0).toUpperCase() + word.slice(1)))
    .join(' ');
}